import React from "react";

import DropDown from "./DropDown";
import Button from "../Button/Button";
import ArrowIcon from "../ArrowIcon/ArrowIcon";
import { Typography } from "@/shared/components";

const DropDownVariantButton = ({
  className,
  showArrow = true,
  label,
  buttonProps,
  parentNode,
  boundaryRect,
  children,
  toggleOnMouseOverLeave,
  closeOnPathnameChange,
  clamp,
  btnRef,
  popupProps,
  onShow,
  ...restProps
}) => {
  return (
    <DropDown
      className={className}
      closeOnPathnameChange={closeOnPathnameChange}
      toggleOnMouseOverLeave={toggleOnMouseOverLeave}
      boundaryRect={boundaryRect ?? parentNode?.getBoundingClientRect()}
      toggleOnClickButton
      onShow={onShow}
      button={({
        show,
        onClick,
      }) => {
        return (
          <Button
            ref={btnRef}
            type="button"
            variant={Button.variant.clear}
            color={Button.color.icon}
            fontFamily={Button.fontFamily.roboto}
            active={show}
            aria-label={label}
            {...buttonProps}
            onClick={buttonProps?.onClick ? (e) => {
              let prevented = false;

              buttonProps.onClick(e, () => {
                prevented = true;
              });

              if (!prevented) {
                onClick(e);
              }
            } : onClick}
          >
            <Typography threeDots={!clamp} clamp={clamp}>{label}</Typography>&nbsp;
            {showArrow
              ? <ArrowIcon direction={show ? ArrowIcon.direction.DOWN : ArrowIcon.direction.RIGHT}/>
              : ""}
          </Button>
        );
      }}
      body={children}
      popupProps={popupProps}
      {...restProps}
    />
  );
};

export default DropDownVariantButton;
